module.exports = "<div class=\"loadWrapper\" *ngIf=\"showProgress\">  \n    <div class=\"loader\"></div>  \n  </div>"